import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import {
  myLocationsQuery,
  useLocationEligibilityLookup,
} from '@b-stock/fe-core/bstock-next/queries'
import { LocationAttribute } from '@b-stock/location-api-client'
import { LocationEligibilityDtoGeofencingEnum } from '@b-stock/shipment-api-client'

/**
 * Whether any of the buyer's saved deliverable addresses is inside the listing's
 * geofence. Backs the `geofence_listing_any_address_within_radius` bid-confirm analytics
 * prop. Returns false while loading or when no deliverable addresses exist.
 */
export const useAnyAddressWithinRadius = (listingId: string): boolean => {
  const accountId = useDecodedAccessToken()?.accountId ?? ''

  const { data: locationsData } = myLocationsQuery.useWithOpts(
    [
      {
        accountId: [accountId],
        attributes: [LocationAttribute.Deliverable],
        includeAllResults: true,
      },
    ],
    { enabled: !!accountId }
  )

  const deliverableIds = (locationsData?.locations ?? [])
    .map((location) => location.id)
    .filter((id): id is string => !!id)

  const { lookupTable } = useLocationEligibilityLookup(
    listingId,
    deliverableIds
  )

  // False covers both "confirmed out-of-zone" and "not yet resolved" per spec.
  return Object.values(lookupTable).some(
    (entry) => entry.geofencing === LocationEligibilityDtoGeofencingEnum.Inzone
  )
}
